<template>
  <div class="messageWrap bgcScN2">
      <div class="newsBox bgcScW flexCol">
          <div class="newsTitle fontH2 fontScN8 rowAc">{{newsData.title}}</div>
          <div class="createBox fontH3 fontScN6 rowAc">
              <div class="personBox rowAc">
                  <img src="../../assets/static/user.svg" class="icon" alt="">
                  <div>{{newsData.createUserName}}</div>
              </div>
              <div class="timeBox rowAc">
                  <img src="../../assets/static/time-circle.svg" class="icon" alt="">
                  <div>{{newsData.createTime}}</div>
              </div>
          </div>
          <div class="summaryBox bgcScN1 fontScN7 fontH3">
              <img src="../../assets/static/summary.svg" class="summaryIcon" alt="">
              <div>{{newsData.summary}}</div>
          </div>
          <div class="contentBox fontScN7 fontH3" v-html="newsData.note"></div>
      </div>
      <div class="nomoreBox rowJc">
          <div class="nomoreText">没有更多了</div>
      </div>
  </div>
</template>

<script>
import {getNoticeDetailAPI} from '../../utils/api/api'
export default {
    data(){
        return {
            newsData:{},
        }
    },
    created(){
        
        
        if(this.$route.params.newsData) {
            console.log('this.$route.params:',this.$route.params)
            this.newsData = this.$route.params.newsData
        }else if(this.$route.query.id) {
            console.log('this.$route.query.id:',this.$route.query.id)
            getNoticeDetailAPI({id:this.$route.query.id}).then(res => {
                if(res.resultCode == 200) {
                    this.newsData = res.data
                }
            })
        }
        
    }
}
</script>

<style lang="scss" scoped>
.messageWrap{
    width: 100%;
    height: 100%;
    overflow: auto;
}
.newsBox{
    width: 100%;
    padding: 0.19rem 0.2rem 0.44rem;
    box-sizing: border-box;
    .newsTitle {
    font-weight: 500;
    margin-bottom: 10px;
  }
  .createBox{
      margin-bottom: 24px;
      .personBox{
          margin-right: 21px;
      }
  }
  .summaryBox{
      padding: 12px;
      box-sizing: border-box;
      margin-bottom: 16px;
      position: relative;
      .summaryIcon{
          position: absolute;
          left: 6px;
          top: -8px;
          width: 21px;
          height: 16px;
      }
  }
}
.nomoreBox{
    height: 144px;
    .nomoreText{
        color: #C8C9CC;
        line-height: 19px;
        font-size: 13px;
        margin-top: 32px;
    }
}
.icon{
    width: 16px;
    height: 16px;
    margin-right: 4px;
}
// 富文本框样式
/deep/ {
    h1 {
        font-size: 2em !important;
    }
    h1 {
        font-size: 2em !important;
    }
    h2 {
        font-size: 1.5em !important;
    }
    h3 {
        font-size: 1.17em !important;
    }
    h4 {
        font-size: 1em !important;
    }
    h5 {
        font-size: 0.83em !important;
    }
    p {
        font-size: 1em !important;
    }
    ul {
        list-style-type: disc;;
    }
    ol {
        list-style-type: decimal
    }
    /*表情菜单样式*/
    .eleImg{
        cursor: pointer;
        display: inline-block;
        font-size: 18px;
        padding: 0 3px;
    }
    * {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }
    /*分割线样式*/
    hr{
        cursor: pointer;
        display: block;
        height: 0px;
        border: 0;
        border-top: 3px solid #ccc;
        margin: 20px 0;
    }
    .w-e-toolbar,
    .w-e-text-container,
    .w-e-menu-panel {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        background-color: #fff;
        
    }

    .w-e-clear-fix:after {
        content: "";
        display: table;
        clear: both;
    }

    .w-e-drop-list-item {
        position: relative;
        top: 1px;
        padding-right: 7px;
        color: #333 !important;
    }

    .w-e-drop-list-tl {
        padding-left: 10px;
        text-align: left;
    }
    .w-e-toolbar {
    .w-e-droplist {
        position: absolute;
        left: 0;
        top: 0;
        background-color: #fff;
        border: 1px solid #f1f1f1;
        border-right-color: #ccc;
        border-bottom-color: #ccc;

        .w-e-dp-title {
            text-align: center;
            color: #999;
            line-height: 2;
            border-bottom: 1px solid #f1f1f1;
            font-size: 13px;
        }

        ul.w-e-list {
            list-style: none;
            line-height: 1;

            li.w-e-item {
                color: #333;
                padding: 5px 0;

                &:hover {
                    background-color: #f1f1f1;
                }
            }
        }
        
        ul.w-e-block {
            list-style: none;
            text-align: left;
            padding: 5px;

            li.w-e-item {
                display: inline-block;
                padding: 3px 5px;

                &:hover {
                    background-color: #f1f1f1;
                }
            }
        }
    }
    }
    
    
    .w-e-text-container {
    position: relative;

    .w-e-progress {
        position: absolute;
        background-color: #1e88e5;
        top: 0;
        left: 0;
        height: 1px;
    }

    .placeholder {
        color: #D4D4D4;
        position: absolute;
        font-size: 11pt;
        line-height: 22px;
        left: 10px;
        top: 10px;
        user-select: none;
        z-index: -1;
    }
}
.musicIcon {
    width: .26rem;
    height: .26rem;
}
.voiceItem {
    background: #36CFC9;
}
// .w-e-text {
    // padding: 0 10px;
    // overflow-y: auto;

    p,h1,h2,h3,h4,h5,table,pre {
        margin: 10px 0;
        line-height: 1.5;
    }

    ul, ol {
        margin: 10px 0 10px 20px;
    }

    blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
    }

    code {
        display: inline-block;
        background-color: #f1f1f1;
        border-radius: 3px;
        padding: 3px 5px;
        margin: 0 3px;
    }

    pre {

        code {
            display: block;
        }
    }

    table {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;

        td,th {
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            padding: 3px 5px;
            min-height: 30px;
        }

        th {
            border-bottom: 2px solid #ccc;
            text-align: center;
            background-color: #f1f1f1;
        }
    }

    &:focus {
        outline: none;
    }

    img {
        cursor: pointer;

        &:hover {
            box-shadow: 0 0 5px #333;
        }
    }

    .w-e-todo {
        margin:0 0 0 20px;
        li {
            list-style:none;
            font-size: 1em;
            span:nth-child(1) {
                position: relative;
                left: -18px;
                input {
                    position: absolute;
                    margin-right:3px;
                }
                // 防止其他样式通过属性选择器重置input样式
                input[type=checkbox] {
                    top: 50%;
                    margin-top: -6px;
                }
            }
        }
    }
// }

.w-e-tooltip {
    position: absolute;
    display: flex;
    color: #f1f1f1;
    background-color: rgba(0,0,0,.75);
    box-shadow: 0 2px 8px 0 rgba(0,0,0,.15);
    border-radius: 4px;
    padding: 4px 5px 6px;
    justify-content: center;
    align-items: center;
}
// 下箭头
.w-e-tooltip-up::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border: 5px solid rgba(0,0,0,0);
    border-top-color: rgba(0,0,0,.73);
}
// 上箭头
.w-e-tooltip-down::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border: 5px solid rgba(0,0,0,0);
    border-bottom-color: rgba(0,0,0,.73);
}
.w-e-tooltip-item-wrapper {
    cursor: pointer;
    font-size: 14px;
    margin: 0 5px;

    &:hover {
        color: #ccc;
        text-decoration: underline;
    }
}

.w-e-menu-tooltip {
  position: absolute;
  display: flex;
  color: #f1f1f1;
  background-color: rgba(0, 0, 0, .75);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .15);
  border-radius: 4px;
  padding: 4px 5px 6px;
  justify-content: center;
  align-items: center;
}
// 下箭头
.w-e-menu-tooltip-up::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border: 5px solid rgba(0, 0, 0, 0);
  border-top-color: rgba(0, 0, 0, .73);
}

.w-e-menu-tooltip-item-wrapper {
  font-size: 14px;
  margin: 0 5px;
}

}
</style>